let slideshowSwiper = new Swiper('.slideshow .swiper-container', {
	slidesPerView: 'auto',
	//spaceBetween: 24,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	/*pagination: {
		el: '.slideshow .swiper-pagination',
		type: 'custom',
		renderCustom: function (swiper, current, total) {
			return '<span class="swiper-pagination-current">' + current + '</span> <span class="swiper-pagination-separator"></span> <span class="swiper-pagination-total">' + total + '</span>';
		}
	}*/
});



let moduleSlideshowSwiper = new Swiper('.module-slideshow .swiper-container', {
	slidesPerView: 'auto',
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});

$('.module-galleria').each(function () {
	let item = $(this);

	let moduleGalleriaSwiper = new Swiper(item.find('.swiper-container')[0], {
		slidesPerView: 'auto',
		pagination: {
			el: item.find('.swiper-pagination')[0],
			type: "fraction",
		}
	});
});



let sezioneImmobiliSwiper;

enquire.register("screen and (min-width: 992px)", {
	match : function() {
		if ($('.sezione-immobili__slideshow .swiper-slide').length > 1)
		{
			sezioneImmobiliSwiper = new Swiper('.sezione-immobili__slideshow .swiper-container', {
				slidesPerView: 'auto',
				freeMode: true,
				navigation:    {
					nextEl: '.sezione-immobili .swiper-button-next',
					prevEl: '.sezione-immobili .swiper-button-prev',
				},
				breakpoints: {
					992: {
						spaceBetween: 58,
						slidesOffsetBefore: function () {
							return $(this.el).width() / 24 * 9;
						},
						slidesOffsetAfter: 58
					}
				},
				on: {
					slideNextTransitionStart: function () {
						if (!$('.sezione-immobili__header').hasClass('hidden'))
						{
							$('.sezione-immobili__header').addClass('hidden');
							$('.sezione-immobili__v').addClass('translated');
						}
					},
					reachBeginning: function () {
						$('.sezione-immobili__header').removeClass('hidden');
						$('.sezione-immobili__v').removeClass('translated');
					},
				},
			});
		}
	},
	unmatch : function() {
		sezioneImmobiliSwiper.destroy();
	}
});



let relatedCaseHistorySwiper;

enquire.register("screen and (max-width: 991.98px)", {
	match : function() {
		if ($('.related-case-history .case-history-item').length > 1)
		{
			$('.related-case-history .col-lg-7').addClass('swiper-slide').wrapAll('<div class="swiper-container"><div class="swiper-wrapper"></div></div>');

			relatedCaseHistorySwiper = new Swiper('.related-case-history .swiper-container', {
				slidesPerView: 'auto',
				freeMode: true,
				spaceBetween: 24,
				slidesOffsetBefore: 22,
				slidesOffsetAfter: 22
			});
		}
	},
	unmatch : function() {
		$('.related-case-history .swiper-slide').unwrap().unwrap().removeClass('swiper-slide');

		relatedCaseHistorySwiper.destroy();
	}
});



let moduleSlideshowSingoloSwiper = new Swiper('.module-planimetria .swiper-container', {
	slidesPerView: 'auto',
	navigation:    {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	pagination: {
		el: '.swiper-pagination',
		type: "fraction",
	}
});